var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroMoneyImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 76,
    viewBox: "0 0 162 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1708 35.7563H114.101V55.6077H41.1708V35.7563Z",
    fill: "#ECEBFF",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1708 54.7002H114.101V74.5516H41.1708V54.7002Z",
    fill: "#ECEBFF",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31578 35.7563H41.2734V55.6077H6.31578V35.7563Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.271 44.2642H88.2064",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8389 41.7432H40.9168H35.849",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.577 49.9331H107.235",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9159 48.3569H68.9199",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9221 35.7563H85.2031V55.6077H68.9221V35.7563Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51108 45.9868H17.3457",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2666 52.0337H33.2353",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0762 45.4575H25.7563",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51262 42.042H21.0898",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0527 52.0337H26.1281",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.331 16.2505H108.261V36.1019H35.331V16.2505Z",
    fill: "#ECEBFF",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470081 16.25H35.4277V36.1014H0.470081V16.25Z",
    fill: "#514C9F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470081 16.25H35.4277V36.1014H0.470081V16.25Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470081 16.25H35.4277V36.1014H0.470081V16.25Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470081 16.25H35.4277V36.1014H0.470081V16.25Z",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 20.0283H89.7592",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9912 22.2368H35.0691H30.0013",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 30.4268H101.387",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7432 24.6963H93.4569",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0683 28.8564H63.0723",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0725 16.25H79.3535V36.1014H63.0725V16.25Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.663439 26.481H11.498",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.418 32.5332H27.3867",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2295 25.957H19.9096",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664966 22.5356H15.2422",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2051 32.5332H20.2804",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41639 33.2998H95.9961V75.117H5.41639V33.2998Z",
    fill: "#514C9F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41639 33.2998H95.9961V75.117H5.41639V33.2998Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41639 33.2998H95.9961V75.117H5.41639V33.2998Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41639 33.2998H95.9961V75.117H5.41639V33.2998Z",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9072 33.5171V50.9488",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 33.6348V38.9391",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.209 74.9926V59.1958",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66895 75.2332V72.4575",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 75.1104V67.2773",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3271 57.6273V54.3721",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 40.2686V42.1941",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9161 33.2998H95.9961V75.117H15.9161V33.2998Z",
    fill: "#ECEBFF",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1734 68.4468V39.9632C22.7462 39.9632 24.0204 38.6916 24.0204 37.1221H87.4918C87.4918 38.6916 88.766 39.9632 90.3388 39.9632C90.4771 39.9632 90.6082 39.9414 90.7393 39.9196V68.4832C90.6082 68.4614 90.4771 68.4396 90.3388 68.4396C88.766 68.4396 87.4918 69.7112 87.4918 71.2807H24.0204C24.0204 69.7112 22.7462 68.4396 21.1734 68.4396V68.4468ZM55.9636 65.9981C62.4877 65.9981 67.7812 60.7156 67.7812 54.205C67.7812 47.6944 62.4877 42.4119 55.9636 42.4119C49.4396 42.4119 44.146 47.6944 44.146 54.205C44.146 60.7156 49.4396 65.9981 55.9636 65.9981Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2922 33.1768H59.5371V75.0521H52.2922V33.1768Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.878 64.501H132.707V75.1097H101.878V64.501Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.85 64.501H128.774V75.1097H124.85V64.501Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 64.501H123.021V75.1097H121.056V64.501Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3027 53.8545H130.132V64.4632H99.3027V53.8545Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M122.275 53.855H126.199V64.4637H122.275V53.855Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 53.855H120.446V64.4637H118.48V53.855Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M101.878 43.2168H132.707V53.8255H101.878V43.2168Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.85 43.2168H128.774V53.8255H124.85V43.2168Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    fill: "#514C9F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 43.2168H123.021V53.8255H121.056V43.2168Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M103.398 32.5713H134.228V43.18H103.398V32.5713Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M126.379 32.5713H130.304V43.18H126.379V32.5713Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    fill: "#514C9F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 32.5713H124.551V43.18H122.585V32.5713Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.878 21.9346H132.707V32.5433H101.878V21.9346Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M124.85 21.9346H128.774V32.5433H124.85V21.9346Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    fill: "#514C9F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 21.9346H123.021V32.5433H121.056V21.9346Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 64.501H159.472V75.1097H128.643V64.501Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M151.623 64.501H155.548V75.1097H151.623V64.501Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    fill: "#514C9F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 64.501H149.796V75.1097H147.83V64.501Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M126.071 53.8555H156.9V64.4642H126.071V53.8555Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M149.052 53.8555H152.977V64.4642H149.052V53.8555Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    fill: "#514C9F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M145.258 53.8555H147.224V64.4642H145.258V53.8555Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 43.2163H159.472V53.825H128.643V43.2163Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.623 43.2163H155.548V53.825H151.623V43.2163Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    fill: "#514C9F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 43.2163H149.796V53.825H147.83V43.2163Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M130.171 32.5723H161V43.181H130.171V32.5723Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M153.152 32.5723H157.076V43.181H153.152V32.5723Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    fill: "#514C9F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M149.357 32.5723H151.323V43.181H149.357V32.5723Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 21.936H159.472V32.5447H128.643V21.936Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M151.623 21.936H155.548V32.5447H151.623V21.936Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    fill: "#514C9F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 21.936H149.795V32.5447H147.829V21.936Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 11.4634H159.472V22.0721H128.643V11.4634Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M151.623 11.4639H155.548V22.0726H151.623V11.4639Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    fill: "#514C9F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 11.4639H149.795V22.0726H147.829V11.4639Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 1H159.472V11.6087H128.643V1Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M151.623 1H155.548V11.6087H151.623V1Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    fill: "#514C9F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    stroke: "#514C9F",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M147.83 1H149.796V11.6087H147.83V1Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M119.522 74.9488C111.226 74.9488 104.5 68.2374 104.5 59.9585C104.5 51.6796 111.226 44.9683 119.522 44.9683C127.818 44.9683 134.543 51.6796 134.543 59.9585C134.543 68.2374 127.818 74.9488 119.522 74.9488Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M121.027 74.9488C112.731 74.9488 106.006 68.2374 106.006 59.9585C106.006 51.6796 112.731 44.9683 121.027 44.9683C129.324 44.9683 136.049 51.6796 136.049 59.9585C136.049 68.2374 129.324 74.9488 121.027 74.9488Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M121.026 72.7971C113.921 72.7971 108.16 67.0487 108.16 59.9576C108.16 52.8666 113.921 47.1182 121.026 47.1182C128.132 47.1182 133.893 52.8666 133.893 59.9576C133.893 67.0487 128.132 72.7971 121.026 72.7971Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.66825,
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.746 53.9976C126.105 53.9976 126.396 54.2886 126.396 54.6476C126.396 55.0067 126.105 55.2977 125.746 55.2977H124.075C124.035 55.2977 123.996 55.2941 123.958 55.2873H123.349C123.794 55.8114 124.115 56.4293 124.277 57.1025H125.598C125.954 57.1025 126.242 57.3913 126.242 57.7474C126.242 58.1036 125.954 58.3923 125.598 58.3923H124.383C124.315 59.3312 123.94 60.1905 123.351 60.8865C123.351 60.8865 122.895 61.384 122.301 61.6823C121.706 61.9805 120.531 62.1762 120.531 62.1762L124.031 66.8866C124.408 67.393 124.047 68.112 123.416 68.1129C123.173 68.1133 122.944 67.9983 122.798 67.803L118.616 62.1762H117.229C116.873 62.1762 116.584 61.8875 116.584 61.5314C116.584 61.1752 116.873 60.8865 117.229 60.8865H119.497C121.054 60.8865 122.334 59.7942 122.498 58.3923H117.229C116.873 58.3923 116.584 58.1036 116.584 57.7474C116.584 57.3913 116.873 57.1025 117.229 57.1025H122.324C121.895 56.0415 120.792 55.2873 119.497 55.2873H117.229C116.873 55.2873 116.584 54.9986 116.584 54.6424C116.584 54.2863 116.873 53.9976 117.229 53.9976H124.075H124.696H125.746Z",
    fill: "#514C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMoneyImage);
export default __webpack_public_path__ + "static/media/heroMoneyImage.6eb836f615a548544fabf69ee80431cd.svg";
export { ForwardRef as ReactComponent };